"use client";

import React from "react";

const CustomNightGuards: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Custom-Fit Night Guards as a Solution
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        One of the most effective ways to protect your teeth and jaws from the damaging effects of bruxism is by wearing a custom night guard. These dental appliances are designed to fit over your teeth and create a barrier between your upper and lower arches, preventing them from coming into contact with each other.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        A well-fabricated night guard should be comfortable, durable, and easy to clean. It&rsquo;s essential to choose a high-quality, custom-made night guard tailored to your specific needs. At Smile4Me, we use advanced technology and premium materials to create custom night guards that provide optimal protection and comfort.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Our process begins with taking precise impressions of your teeth using digital scanning technology. This ensures an accurate and comfortable fit for your custom night guard. Once the impressions are taken, our skilled dental laboratory team will craft a night guard that is uniquely yours, designed to address your specific bite pattern and provide maximum protection.
      </p>
    </div>
  );
};

export default CustomNightGuards;